<template>
  <div class="pulse-field">
    <span v-if="label" class="pulse-field__label">{{ label }}</span>
    <slot />
  </div>
</template>

<script>
export default {
  name: "PulseField",
  props: {
    label: { type: String, default: "" },
  },
};
</script>
